import React from 'react';
import { Lock } from 'lucide-react';

const AIExcel = () => {
    return (
        <div className="flex flex-col items-center justify-center min-h-[70vh] bg-gray-50 p-6">
            <div className="bg-white p-10 rounded-2xl shadow-xl flex flex-col items-center text-center max-w-lg w-full border border-gray-100">
                <div className="bg-red-50 p-4 rounded-full mb-6">
                    <Lock className="w-12 h-12 text-red-500" />
                </div>
                <h1 className="text-3xl font-black text-gray-800 mb-3 tracking-tight">Access Locked</h1>
                <p className="text-gray-500 mb-8 leading-relaxed font-medium">
                    The Systems Builder (AI Excel) module is currently locked and unavailable for all users, including Administrators.
                </p>
                <div className="bg-gray-50 w-full p-4 rounded-xl text-xs text-gray-400 font-bold tracking-widest uppercase border border-gray-100">
                    System Restriction Active
                </div>
            </div>
        </div>
    );
};

export default AIExcel;